import { render, staticRenderFns } from "./PrintOrderDetails.vue?vue&type=template&id=0cb6f08a&scoped=true"
import script from "./PrintOrderDetails.vue?vue&type=script&lang=js"
export * from "./PrintOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderDetails.vue?vue&type=style&index=0&id=0cb6f08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6f08a",
  null
  
)

export default component.exports